import { IComponentController } from "angular";
import { IEcranDetailsResourcesEntite } from "../../../../../core/resources/ecran-details.resource";
import { IFormulaireItemSautDeLigneClass } from "../../../../../core/services/formulaire/formulaire-item-saut-de-ligne.service";
import { IFormulaireItemClass } from "../../../../../core/services/formulaire/formulaire-item.service";
import { IFormulaire, IFormulaireClass } from "../../../../../core/services/formulaire/formulaire.service";
import { IMonoOccurrence, IMonoOccurrenceOptions } from "../../../../../core/services/mono-occurrence.service";
import { IMultiOccurrence, IMultiOccurrenceOptions } from "../../../../../core/services/multi-occurrence.service";
import { IRoute } from "../../../../../core/interfaces/route.interface";
import { IMenuClass } from "../../../../../core/services/menu/menu.service";
import { IStateService } from "angular-ui-router";
import { IMenuItemActionClass } from "../../../../../core/services/menu/menu-item-action.service";
import { IFormulaireItemMenuItemClass } from '../../../../../core/services/formulaire/formulaire-item-menu-item.service';

interface IPageCp2005 extends IComponentController {
    monoOccurrenceOptions: IMonoOccurrenceOptions;
    monoOccurrence: IMonoOccurrence;
    formulaireRef: IFormulaire;
    mdvMultiOccurrence: IMultiOccurrence;
    mdvMultiOccurrenceOptions: IMultiOccurrenceOptions;
    zrvMultiOccurrenceOptions: IMultiOccurrenceOptions;
    valeursEcran: any;
}
interface ICp2005Params {
    menuId: string;
}
/* @ngInject */
export default function Cp2005Controller(
    Formulaire: IFormulaireClass,
    FormulaireItem: IFormulaireItemClass,
    FormulaireItemMenuItem: IFormulaireItemMenuItemClass,
    FormulaireItemSautDeLigne: IFormulaireItemSautDeLigneClass,
    ecranDetails: IEcranDetailsResourcesEntite,
    Menu: IMenuClass,
    $state: IStateService,
    $stateParams: ICp2005Params,
    MenuItemAction: IMenuItemActionClass,
    cp2005Route: IRoute) {
    const vm = this as IPageCp2005
    vm.$onInit = $onInit;

    vm.valeursEcran = ecranDetails.valeurs;
    function $onInit() {
        vm.monoOccurrenceOptions = {
            hideAutoriserSurMessageAdvertissement: true,
            actionsMore: new Menu([
                new MenuItemAction(
                    'LBL_COPIE_PAIMENT',
                    'BOUCOP',
                    (rowData: any) => ({ zracleint: rowData.zracleint }),
                    {
                        icon: 'content_copy',
                        fonction: 'BOUACT',
                        successAction: (rowData: any) => {
                            $state.go(cp2005Route.NAME, { id: rowData.zracleintnew, menuId: $stateParams.menuId });
                        }
                    }
                )]),
            fonctions: {
                boutonDupliquer: false
            },
            successActionSauvegarde: () => vm.monoOccurrence.fetchData(),
            formulaire: new Formulaire('LBL_TITRE', [
                new FormulaireItem("zranumdoc"),
                new FormulaireItem("zczcleint"),
                new FormulaireItem("refdesc", {
                    hidden: () => (!vm.monoOccurrence.data.zracleint),
                    readonly: true,
                    menu: [
                        new MenuItemAction(
                            'LBL_FOURNISSEUR',
                            'BOUCHGFOU',
                            () => ({}),
                            {
                                icon: 'edit',
                                fonction: 'BTN_CHGFOU',
                                formulaireConfirmationAction: {
                                    lblTitre: 'LBL_CHGFOU',
                                    lblConfirm: '',
                                    largeurFormulaire: 30,
                                    formulaire: new Formulaire([
                                        new FormulaireItem('refdesc', { readonly: true }),
                                        new FormulaireItem('refcleintnew')
                                    ], { largeurDefaut: 100 })
                                },
                                successAction: () => { vm.monoOccurrence.fetchData(); },
                            },
                        ),
                    ],
                }),
                new FormulaireItem("refcleint", { hidden: () => (vm.monoOccurrence.data.zracleint || vm.valeursEcran.type === 1), }),
                new FormulaireItem("zrafounom", { hidden: (vm.valeursEcran.type === 0) }),
                new FormulaireItem('docdesc', {
                    hidden: () => (!vm.monoOccurrence.data.zracleint),
                    readonly: true,
                    menu: [
                        new MenuItemAction(
                            'LBL_NOCOMMANDE',
                            'BOUCHGCMD',
                            () => ({}),
                            {
                                icon: 'edit',
                                fonction: 'BTN_AFFCMD',
                                formulaireConfirmationAction: {
                                    lblTitre: 'LBL_MODCMDCON',
                                    lblConfirm: '',
                                    largeurFormulaire: 30,
                                    formulaire: new Formulaire([
                                        new FormulaireItem('docdesc', { readonly: true }),
                                        new FormulaireItem('t_doccleintref', { resourceParams: (data: any) => ({ zradat: data.zradat }) })
                                    ], { largeurDefaut: 100 })
                                },
                                successAction: () => { vm.monoOccurrence.fetchData(); },
                            },
                        ),
                    ],
                }),
                new FormulaireItem('doccleintref', { hidden: () => (vm.monoOccurrence.data.zracleint || vm.valeursEcran.type === 1) }),
                new FormulaireItem("zradocref", { hidden: (vm.valeursEcran.type === 0) }),
                new FormulaireItem("zraadr", { hidden: (vm.valeursEcran.type === 0) }),
                new FormulaireItem("zranas", { hidden: (vm.valeursEcran.type === 0) }),
                new FormulaireItem("radcleint", { hidden: (ecranDetails.flgcen === 0 || vm.valeursEcran.type === 1) ? true : false }),
                new FormulaireItem("zranumref", { required: true, maxlength: 25 }),
                new FormulaireItem("zradat", { required: true }),
                new FormulaireItemSautDeLigne(),
                new FormulaireItem("zramnttot", { required: true }),
                new FormulaireItem("vaesysdevcod", { readonly: (data: any) => (vm.valeursEcran.type === 0 || (data.refcleint)) }),
                new FormulaireItem("zradsc", { largeur: 100 }),
                new FormulaireItem("zradscext", { largeur: 100 }),
                new FormulaireItem("flgcen", { default: ecranDetails.flgcen, hidden: true }),
                new FormulaireItem("isportail", { default: 0, hidden: true })
            ], { piecesJointes: true })
        }

        vm.formulaireRef = new Formulaire('LBL_INFO', [
            new FormulaireItem("zrafounom"),
            new FormulaireItem("zradocref"),
            new FormulaireItem("zraadr"),
            new FormulaireItem("zranas")
        ], { largeurDefaut: 100 });

        // Pour les ventilations non reliées à des commandes
        vm.zrvMultiOccurrenceOptions = {
            colonnesVisibles: [
                { nom: "zrvimp", largeur: 200 },
                { nom: "qvcdsc", largeur: 200 }
            ],
            colonnesCachees: ["prucleint", "cptcleint", "cifcleint", "prscleint", "unacleint", "el1cleint", "el2cleint", "el3cleint"],
            formulaire: new Formulaire([
                new FormulaireItem("zrvimp"),
                new FormulaireItem('qvcdsc', { maxlength: 120 })
            ])
        }

        // Pour les ventilations reliées à des commandes
        vm.mdvMultiOccurrenceOptions = {
            resourceParamsDynamique: () => ({
                zracleint: vm.monoOccurrence.data.zracleint,
                doccleint: vm.monoOccurrence.data.doccleintref
            }),
            colonnesCachees: ["mdvcleint"],
            colonnesVisibles: [
                { nom: "mdvimp", largeur: 200 },
                { nom: "mdvdsc", largeur: 200 },
                { nom: "qvcdsc", largeur: 200 }

            ],
            formulaire: new Formulaire([
                new FormulaireItem('qvcdsc', { largeur: 60, maxlength: 120 })
            ])
        }
        
    }
}